/* tslint:disable */
/* eslint-disable */
export enum PermissionName {
  Owner = 'owner',
  Manager = 'manager'
}
